import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import ApiService from "@/services/api.service";
import { useAuthStore } from "@/store/auth";

interface UserVersionResponse {
  success: boolean;
  message?: string;
  data: {
    version: number | null;
  };
}

/**
 * Composable to fetch user version data
 * Used to determine which version of the dashboard and API the user can access
 */
export function useUserVersion() {
  const authStore = useAuthStore();
  const userId = computed(() => authStore.user?.id ?? null);
  const hasSession = computed(() => Boolean(authStore.token && userId.value));

  const { data, isLoading, error } = useQuery({
    queryKey: computed(() => ["user", "version", userId.value]),
    queryFn: async () => {
      // TODO: Replace this garbage with useApi() from @shopexperts/shared
      const response = await ApiService.get("/user-version");
      return response.data as UserVersionResponse;
    },
    enabled: hasSession,
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  });

  const version = computed(() => data.value?.data?.version ?? null);

  return {
    version,
    isLoading,
    error,
  };
}

export default useUserVersion;
